import styled from 'styled-components';

interface Props {
  isMobile?: boolean;
  isTablet?: boolean;
  isWeb?: boolean;
  maxWidth?: string;
}

const PageInner = styled.div<Props>`
  width: 100%;
  max-width: ${props => props.maxWidth || '1100px'};
  background-color: ${props => props.theme.colors.htmlBackground};
  padding: ${props => (props.isTablet || props.isMobile ? '0 20px' : `${props.theme.space[3]}px`)};
`;

export default PageInner;
